import { Trans } from '@lingui/macro'
import { Button, FormHelperText } from '@material-ui/core'
import { Launch } from '@material-ui/icons'
import React from 'react'
import { IAccount } from 'shopify-payment-core'

interface IProps {
  account: IAccount
  onClick?(): void
}

const GATEWAY_ID = '1052051' // GoPay

export const InstallGatewayButton: React.FC<IProps> = ({
  account,
  onClick,
}) => {
  return (
    <>
      <Button
        variant="contained"
        component="a"
        href={`https://${account.shopName}.myshopify.com/admin/authorize_gateway/${GATEWAY_ID}`}
        target="_blank"
        onClick={onClick}
      >
        <Trans>Instalace brány do Shopify</Trans>
        <Launch />
      </Button>
      <FormHelperText>
        <Trans>Bude vyžadováno přihlášení do Vašeho obchodu.</Trans>
      </FormHelperText>
    </>
  )
}
